import React, { memo } from "react";

import { SubtleBadge } from "components/Badge";
import { FormCollapse } from "components/Form";
import { Row } from "components/Layout";
import { MoneyTableWrapper } from "components/MoneyTable/MoneyTable";

import { AgGridTables } from "constants/aggrid";

function BusinessTransactionsHeader() {
  return (
    <Row>
      <SubtleBadge>Transactions</SubtleBadge>
    </Row>
  );
}

const BusinessTransactions = ({ businessId, isOpen, onToggle }) => {
  return (
    <FormCollapse
      isOpen={isOpen}
      onToggle={onToggle}
      header={<BusinessTransactionsHeader />}
      dataTour="transactionsCollapse"
    >
      <Row minHeight="600px" fullWidth flex={false}>
        <MoneyTableWrapper
          businessId={businessId}
          tableName={AgGridTables.BUSINESS_MONEY}
        />
      </Row>
    </FormCollapse>
  );
};

export default memo(BusinessTransactions);
